import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
// components
// middlewares
import { Link, matchPath, useLocation, useNavigation } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import PaymentSellingMiddleware from "../../../../middleware/modules/sales/payment-selling";
import Form from "../../../../components/modules/sales/payment-selling/form";
import { Helmet } from "react-helmet";
import i18n from "../../../../i18n";

const mapStateToProps = ({ auth, paymentSelling }) => ({
  isAuthenticated: auth.isAuthenticated,
  isProcessing: paymentSelling.isProcessing,
  isError: paymentSelling.isError,
  errorMessage: paymentSelling.errorMessage,
  data: paymentSelling.dataPaymentSelling,
  type: paymentSelling.type,
  isSuccess: paymentSelling.isSuccess,
  isReset: paymentSelling.isReset,
  isNewRecord: paymentSelling.isNewRecord,
  onSubmit: paymentSelling.onSubmit,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      closeModal: () => PaymentSellingMiddleware.reset(),
      new: (data, search) => PaymentSellingMiddleware.beforeSaveNew(data, search),
      update: (id, type, search) =>
        PaymentSellingMiddleware.beforeSaveUpdate(id, type, search),
      create: () => PaymentSellingMiddleware.create(),
      getPo: (date, idSupplier) => PaymentSellingMiddleware.getPo(date, idSupplier),
    },
    dispatch
  );
};
class FormContainer extends Component {
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    isSuccess: PropTypes.bool,
    errorMessage: PropTypes.any,
    onSubmit: PropTypes.bool,
    type: PropTypes.string,
  };

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isSuccess: false,
    isError: false,
    errorMessage: [],
    type: "multiple",
    onSubmit: false,
  };
  constructor(props) {
    super(props);
    this.state = {
      modal: {
        title: "",
        show: false,
      },
    };
    this.form = React.createRef();
    this.submitForm = this.submitForm.bind(this);
    this.close = this.close.bind(this);
  }

  close() {
    this.props.closeModal();
  }
  submitForm() {
    const { search, isNewRecord, dataUpdate } = this.props;
    var form = this.form.current.runSubmit();
    if(form.PaymentConfirmationDetail.idInvoice.length > 0){
    this.props.new(form, search);
    }else{
      alert(i18n.t("Must Choose atleast 1 invoice"))
    }
    
  }

  getPO() {
    this.props.getPo;
  }

  render() {
    const { onSubmit, showModal, titleModal } = this.props;

    return (
      <>
        <Modal show={showModal} fullscreen enforceFocus={false}>
          <Modal.Header>
            <Modal.Title>{titleModal}</Modal.Title>
          </Modal.Header>
          <Helmet>
            <title>{titleModal}</title>
          </Helmet>
          <Modal.Body>
            <Form {...this.props} ref={this.form} />
          </Modal.Body>
          <Modal.Footer
            className={
              !onSubmit ? "justify-content-between" : "justify-content-center"
            }
          >
            {onSubmit ? (
              ""
            ) : (
              <Button variant="secondary" onClick={() => this.close(false)}>
                {i18n.t("Close")}
              </Button>
            )}
            <Button
              variant="primary"
              onClick={() => (onSubmit ? false : this.submitForm(true))}
            >
              {onSubmit ? (
                <span className="indicator-progress show">
                  {i18n.t("Please wait...")}
                  <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                </span>
              ) : (
                <span className="indicator-label">{i18n.t("Save")}</span>
              )}
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FormContainer);
